
<div class="font-20 semibold mtb-20">
  <font class="font-required">*</font>
  Address Verification
  <font class="font-required">(Required)</font>
</div>
<div class="container mb-10">
  Please confirm your physical and mailing address information. You may edit existing, add new or delete old address information. Please note that at least one current address must be entered and confirmed.
</div>
<div class="flex-row pb-20 mt-10">
  <div class="card fluid">
    <div class="card__content">
      <!-- This is the alert message upon the confirmation checkbox being checked -->
      @if (homephysicaladdress.isConfirm==true) {
        <app-alert></app-alert>
      }
      <div class="flex">
        <div>
          <div class="mb-10">
            <button title="Edit Physical Address" (click)="address(homephysicaladdress,1)" class="soft white rounded-full gray-300 hover-blue-500" aria-label="Edit">
              <div class="icon icon-black">
                <i class="fas fa-pen"></i>
              </div>
            </button>
          </div>
          @if (homephysicaladdress.addressI) {
            <div class="mt-10">
              <button (click)="delete(1)" id="" title="Delete Physical Address" style="padding: 0 7px;"
                class="secondary border-red rounded-full hover-red hover-font-white flex-row-reverse">
                <div class="icon trash icon-red font-20">
                  <i class="fas fa-trash"></i>
                </div>
              </button>
            </div>
          }
          @if (!homephysicaladdress.addressI) {
            <div class="mt-10">
              <button (click)="delete(1)" id="" title="Delete Physical Address" style="padding: 0 7px;"
                class="disabled secondary border-red rounded-full hover-red hover-font-white flex-row-reverse">
                <div class="icon trash icon-red font-20">
                  <i class="fas fa-trash"></i>
                </div>
              </button>
            </div>
          }
        </div>
        <div class="width-full mt-10 pl-20">
          <div class="flex mobile-address">
            <div class="width-half">
              <div class="mb-20">
                <b>Home Physical Address</b>
              </div>
              @if (homephysicaladdress.addressI) {
                <div class="mb-20">
                  {{homephysicaladdress?.addressI}},
                  {{homephysicaladdress?.city}},
                  {{homephysicaladdress?.state}},
                  {{homephysicaladdress?.zipCode}}@if (homephysicaladdress.zipCode4) {
                  <span>-{{homephysicaladdress?.zipCode4}}</span>
                }
              </div>
            }
          </div>
          @if (homephysicaladdress.oedsAddressKey!=0 && homephysicaladdress.addressI && homephysicaladdress.actionType !== 'Updated') {
            <div class="width-half flex check-confirm justify-end mt-40">
              <span class="select-entire checkbox-yellow">
                <!-- click on confirm pops up alert message at the top of the card -->
                <input (change)="alert(1)" type="checkbox" id="home-physical" name="entire" value="entire" [checked]="homephysicaladdress.isConfirm==true" [(ngModel)]="homephysicaladdress.isConfirm">
                <label for="home-physical"> I confirm this is accurate</label>
              </span>
            </div>
          }
        </div>
        <div class="display-block">
          <hr>
          </div>
        </div>
      </div>
      <!-- This is the delete confirmation located in the shared folder -->
      @if (cservice.action==='Delete1') {
        <ng-container (doCancel)="delete(1)">
          <div class="inset-blur fade  gray-200 p-10 mt-10">
            <app-delete-confirmation (doCancel)="delete(1)" (doDelete)="confirmDelete(homephysicaladdress.oedsAddressType,homephysicaladdress.oedsLocationType,0)"></app-delete-confirmation>
          </div>
        </ng-container>
      }
      <!-- This is the form that users will use to update address -->
      @if (cservice.action==='Address1') {
        <ng-container (doCancel)="delete(1)">
          <div class="flex">
            <span class="flex justify-start font-18 form mt-10 basis-50"><b>Update</b></span>
            <span class="flex justify-end font-required form mt-10 basis-50"><b>*Required</b></span>
          </div>
          <div class="inset-blur fade  gray-200 p-10">
            <app-contact-verification-address-form (doCancel)="cancelUpdate()" [selectedaddress]="cservice.selectedaddress" [stateslist]="cservice.statesList"></app-contact-verification-address-form>
          </div>
        </ng-container>
      }
    </div>
  </div>
</div>
<!-- New card section -->
<div class="flex-row pb-20 mt-10">
  <div class="card fluid">
    <div class="card__content">
      @if (homemailingaddress.isConfirm==true) {
        <app-alert></app-alert>
      }
      <div class="flex">
        <div>
          <div class="mb-10">
            <button title="Edit Mailing Address" (click)="address(homemailingaddress,2)" class="soft white rounded-full gray-300 hover-blue-500" aria-label="Edit">
              <div class="icon icon-black">
                <i class="fas fa-pen"></i>
              </div>
            </button>
          </div>
          @if (homemailingaddress.addressI) {
            <div class="mt-10">
              <button (click)="delete(2)" id="" title="Delete Mailing Address" style="padding: 0 7px;"
                class="secondary border-red rounded-full hover-red hover-font-white flex-row-reverse">
                <div class="icon trash icon-red font-20">
                  <i class="fas fa-trash"></i>
                </div>
              </button>
            </div>
          }
          @if (!homemailingaddress.addressI) {
            <div class="mt-10">
              <button (click)="delete(2)" id="" title="Delete Mailing Address" style="padding: 0 7px;"
                class="disabled secondary border-red rounded-full hover-red hover-font-white flex-row-reverse">
                <div class="icon trash icon-red font-20">
                  <i class="fas fa-trash"></i>
                </div>
              </button>
            </div>
          }
        </div>
        <div class="width-full mt-10 pl-20">
          <div class="flex mobile-address">
            <div class="width-half">
              <div class="mb-20">
                <b>Home Mailing Address</b>
              </div>
              @if (homemailingaddress.addressI) {
                <div class="mb-20">
                  {{homemailingaddress?.addressI}},
                  {{homemailingaddress?.city}},
                  {{homemailingaddress?.state}},
                  {{homemailingaddress?.zipCode}}@if (homemailingaddress.zipCode4) {
                  <span>-{{homemailingaddress?.zipCode4}}</span>
                }
              </div>
            }
          </div>
          @if (homemailingaddress.oedsAddressKey!=0 && homemailingaddress.addressI && homemailingaddress.actionType !== 'Updated') {
            <div class="width-half flex check-confirm justify-end mt-40">
              <span class="select-entire checkbox-yellow">
                <input (change)="alert(2)" type="checkbox" id="home-mailing" name="entire" value="entire" [checked]="homemailingaddress.isConfirm==true" [(ngModel)]="homemailingaddress.isConfirm">
                <label for="home-mailing"> I confirm this is accurate</label>
              </span>
            </div>
          }
        </div>
        <div class="display-block">
          <hr>
          </div>
        </div>
      </div>
      <!-- This is the delete confirmation located in the shared folder -->
      @if (cservice.action==='Delete2') {
        <ng-container (doCancel)="delete(2)">
          <div class="inset-blur fade  gray-200 p-10 mt-10">
            <app-delete-confirmation (doCancel)="delete(2)" (doDelete)="confirmDelete(homemailingaddress.oedsAddressType,homemailingaddress.oedsLocationType,1)"></app-delete-confirmation>
          </div>
        </ng-container>
      }
      <!-- This is the form that users will use to update address -->
      @if (cservice.action==='Address2') {
        <ng-container (doCancel)="delete(2)">
          <div class="flex">
            <span class="flex justify-start font-18 form mt-10 basis-50"><b>Update</b></span>
            <span class="flex justify-end font-required form mt-10 basis-50"><b>*Required</b></span>
          </div>
          <div class="inset-blur fade  gray-200 p-10">
            <app-contact-verification-address-form (doCancel)="cancelUpdate()" [selectedaddress]="cservice.selectedaddress" [stateslist]="cservice.statesList"></app-contact-verification-address-form>
          </div>
        </ng-container>
      }
    </div>
  </div>
</div>

<!-- New card section -->
@if (cservice.isUserOrgMappingExist || cservice.hasOfficePhysicalAddress) {
  <div class="flex-row pb-20 mt-10">
    <div class="card fluid">
      <div class="card__content">
        @if (officephysicaladdress.isConfirm==true) {
          <app-alert></app-alert>
        }
        <div class="flex">
          <div>
            <div class="mb-10">
              <button title="Edit Physical Address" (click)="address(officephysicaladdress,4)" class="soft white rounded-full gray-300 hover-blue-500" aria-label="Edit">
                <div class="icon icon-black">
                  <i class="fas fa-pen"></i>
                </div>
              </button>
            </div>
            @if (officephysicaladdress.addressI) {
              <div class="mt-10">
                <button (click)="delete(4)" id="" title="Delete Physical Address" style="padding: 0 7px;"
                  class="secondary border-red rounded-full hover-red hover-font-white flex-row-reverse">
                  <div class="icon trash icon-red font-20">
                    <i class="fas fa-trash"></i>
                  </div>
                </button>
              </div>
            }
            @if (!officephysicaladdress.addressI) {
              <div class="mt-10">
                <button (click)="delete(4)" id="" title="Delete Physical Address" style="padding: 0 7px;"
                  class="disabled secondary border-red rounded-full hover-red hover-font-white flex-row-reverse">
                  <div class="icon trash icon-red font-20">
                    <i class="fas fa-trash"></i>
                  </div>
                </button>
              </div>
            }
          </div>
          <div class="width-full mt-10 pl-20">
            <div class="flex mobile-address">
              <div class="width-half">
                <div class="mb-20">
                  <b>Office Physical Address</b>
                </div>
                @if (officephysicaladdress.addressI) {
                  <div class="mb-20">
                    {{officephysicaladdress?.addressI}},
                    {{officephysicaladdress?.city}},
                    {{officephysicaladdress?.state}},
                    {{officephysicaladdress?.zipCode}}@if (officephysicaladdress.zipCode4) {
                    <span>-{{officephysicaladdress?.zipCode4}}</span>
                  }
                </div>
              }
            </div>
            @if (officephysicaladdress.oedsAddressKey!=0 && officephysicaladdress?.addressI && officephysicaladdress.actionType !== 'Updated') {
              <div class="width-half flex check-confirm justify-end mt-40">
                <span class="select-entire checkbox-yellow">
                  <input (change)="alert(4)" type="checkbox" id="office-physical" name="entire" value="entire" [checked]="officephysicaladdress.isConfirm==true" [(ngModel)]="officephysicaladdress.isConfirm">
                  <label for="office-physical"> I confirm this is accurate</label>
                </span>
              </div>
            }
          </div>
          <div class="display-block">
            <hr>
            </div>
          </div>
        </div>
        <!-- This is the delete confirmation located in the shared folder -->
        @if (cservice.action==='Delete4') {
          <ng-container (doCancel)="delete(4)">
            <div class="inset-blur fade  gray-200 p-10 mt-10">
              <app-delete-confirmation (doCancel)="delete(4)" (doDelete)="confirmDelete(officephysicaladdress.oedsAddressType,officephysicaladdress.oedsLocationType,3)"></app-delete-confirmation>
            </div>
          </ng-container>
        }
        <!-- This is the form that users will use to update address -->
        @if (cservice.action==='Address4') {
          <ng-container (doCancel)="delete(4)">
            <div class="flex">
              <span class="flex justify-start font-18 form mt-10 basis-50"><b>Update</b></span>
              <span class="flex justify-end font-required form mt-10 basis-50"><b>*Required</b></span>
            </div>
            <div class="inset-blur fade  gray-200 p-10">
              <app-contact-verification-address-form (doCancel)="cancelUpdate()" [selectedaddress]="cservice.selectedaddress" [stateslist]="cservice.statesList"></app-contact-verification-address-form>
            </div>
          </ng-container>
        }
      </div>
    </div>
  </div>
}
<!-- New card section -->
@if (cservice.isUserOrgMappingExist || cservice.hasOfficeMailingAddress) {
  <div class="flex-row pb-20 mt-10" >
    <div class="card fluid">
      <div class="card__content">
        @if (officemailingaddress.isConfirm==true) {
          <app-alert></app-alert>
        }
        <div class="flex">
          <div>
            <div class="mb-10">
              <button title="Edit Mailing Address" (click)="address(officemailingaddress,3)" class="soft white rounded-full gray-300 hover-blue-500" aria-label="Edit">
                <div class="icon icon-black">
                  <i class="fas fa-pen"></i>
                </div>
              </button>
            </div>
            @if (officemailingaddress.addressI) {
              <div class="mt-10">
                <button (click)="delete(3)" id="" title="Delete Mailing Address" style="padding: 0 7px;"
                  class="secondary border-red rounded-full hover-red hover-font-white flex-row-reverse">
                  <div class="icon trash icon-red font-20">
                    <i class="fas fa-trash"></i>
                  </div>
                </button>
              </div>
            }
            @if (!officemailingaddress.addressI) {
              <div class="mt-10">
                <button (click)="delete(3)" id="" title="Delete Mailing Address" style="padding: 0 7px;"
                  class="disabled secondary border-red rounded-full hover-red hover-font-white flex-row-reverse">
                  <div class="icon trash icon-red font-20">
                    <i class="fas fa-trash"></i>
                  </div>
                </button>
              </div>
            }
          </div>
          <div class="width-full mt-10 pl-20">
            <div class="flex mobile-address">
              <div class="width-half">
                <div class="mb-20">
                  <b>Office Mailing Address</b>
                </div>
                @if (officemailingaddress.addressI) {
                  <div class="mb-20">
                    {{officemailingaddress?.addressI}},
                    {{officemailingaddress?.city}},
                    {{officemailingaddress?.state}},
                    {{officemailingaddress?.zipCode}}@if (officemailingaddress.zipCode4) {
                    <span>-{{officemailingaddress?.zipCode4}}</span>
                  }
                </div>
              }
            </div>
            @if (officemailingaddress.oedsAddressKey!=0 && officemailingaddress.addressI && officemailingaddress.actionType !== 'Updated') {
              <div class="width-half flex check-confirm justify-end mt-40">
                <span class="select-entire checkbox-yellow">
                  <input (change)="alert(3)" type="checkbox" id="office-mailing" name="entire" value="entire" [checked]="officemailingaddress.isConfirm==true" [(ngModel)]="officemailingaddress.isConfirm">
                  <label for="office-mailing"> I confirm this is accurate</label>
                </span>
              </div>
            }
          </div>
          <div class="display-block">
            <hr>
            </div>
          </div>
        </div>
        <!-- This is the delete confirmation located in the shared folder -->
        @if (cservice.action==='Delete3') {
          <ng-container (doCancel)="delete(3)">
            <div class="inset-blur fade  gray-200 p-10 mt-10">
              <app-delete-confirmation (doCancel)="delete(3)" (doDelete)="confirmDelete(officemailingaddress.oedsAddressType,officemailingaddress.oedsLocationType,2)"></app-delete-confirmation>
            </div>
          </ng-container>
        }
        <!-- This is the form that users will use to update address -->
        @if (cservice.action==='Address3') {
          <ng-container (doCancel)="delete(3)">
            <div class="flex">
              <span class="flex justify-start font-18 form mt-10 basis-50"><b>Update</b></span>
              <span class="flex justify-end font-required form mt-10 basis-50"><b>*Required</b></span>
            </div>
            <div class="inset-blur fade  gray-200 p-10">
              <app-contact-verification-address-form (doCancel)="cancelUpdate()" [selectedaddress]="cservice.selectedaddress" [stateslist]="cservice.statesList"></app-contact-verification-address-form>
            </div>
          </ng-container>
        }
      </div>
    </div>
  </div>
}
<div class="divider gray-500 mtb-20"></div>
<div class="container flex mobile">
  <span class="basis-33">
    <span class="flex justify-start">
      <button id="" title="Back" class="secondary border-red rounded-full hover-red hover-font-white flex-row-reverse mobile" (click)="updatestepcount(false)">
        <div class="btn-txt font-red bold">Back</div>
      </button>
    </span>
  </span>
  <!--<span class="basis-33">
  <span class="flex justify-center">
    <button id="" title="Skip Verification" class="secondary border-red rounded-full hover-red hover-font-white flex-row-reverse mobile" (click)="cservice.backtoapplication()">
      <div class="btn-txt font-red bold">Skip Verification for Now</div>
    </button>
  </span>
</span>-->
<span class="basis-33">
  <span class="flex justify-end">
    <button title="Next" class="rounded-full hover-blue-800 black mobile" (click)="updatestepcount(true)" [disabled]="getIsFormvalid()">
      <div class="btn-txt font-white bold">Next</div>
    </button>
  </span>
</span>
</div>

